export default {
  anchorNameChanged: {
    evid: 1145,
    fields: {},
  },
};
